import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import axios from "axios";
import { ParsedRecord } from "../../types/airtable";

// Action Definitions
export interface FetchRecordsBegin {
  type: "FETCH_RECORDS_BEGIN";
}
export interface FetchRecordsSuccess {
  type: "FETCH_RECORDS_SUCCESS";
  payload: any;
}
export interface FetchRecordsFailure {
  type: "FETCH_RECORDS_FAILURE";
  error: any;
}

// Union Action Types
// export type Action = SetAction | SetFetching;
export type Action =
  | FetchRecordsBegin
  | FetchRecordsSuccess
  | FetchRecordsFailure;

// Action Creators
export const fetchRecordsBegin = (): FetchRecordsBegin => {
  return { type: "FETCH_RECORDS_BEGIN" };
};
export const fetchRecordsSuccess = (
  payload: ParsedRecord[]
): FetchRecordsSuccess => {
  console.log("records loaded");
  return { type: "FETCH_RECORDS_SUCCESS", payload };
};
export const fetchRecordsFailure = (error: Error): FetchRecordsFailure => {
  console.log(error);
  return { type: "FETCH_RECORDS_FAILURE", error };
};

export const getRecords = (): ThunkAction<
  Promise<void>,
  unknown,
  unknown,
  AnyAction
> => {
  return async (
    dispatch: ThunkDispatch<unknown, unknown, AnyAction>
  ): Promise<void> => {
    dispatch(fetchRecordsBegin());
    try {
      const response = await axios.get("/api/dashboard");
      console.log(response);
      const records: ParsedRecord[] = response.data.main.records.map(
        (record: any) => new ParsedRecord(record, response.data.images)
      );
      dispatch(fetchRecordsSuccess(records));
    } catch (error: any) {
      dispatch(fetchRecordsFailure(error));
    }
  };
};
